<template>
  <v-container
    class="align-content-start"
    fill-height
    fluid
  >
    <v-row>
      <section-header
        :breadcrumb-items="breadcrumb"
      />
    </v-row>

    <!-- Tabs -->
    <v-row>
      <v-col cols="12">
        <div class="d-flex align-center justify-space-between">
          <v-tabs
            v-model="activeTab"
            active-class="active-tab"
            background-color="transparent"
            height="30"
            hide-slider
            show-arrows
          >
            <v-tab :href="`#${$t('Rates.Tab.Regressions.Slug')}`">
              {{ $t('Rates.Tab.Regressions.Title') }}
            </v-tab>
            <v-tab :href="`#${$t('Rates.Tab.Peers.Slug')}`">
              {{ $t('Rates.Tab.Peers.Title') }}
            </v-tab>
          </v-tabs>
        </div>
      </v-col>
    </v-row>

    <!-- Tabs Content -->
    <v-row ref="alm">
      <v-col cols="12">
        <v-tabs-items
          v-model="activeTab"
          class="fill-height"
        >
          <!-- Regressions Tab -->
          <v-tab-item :value="$t('Rates.Tab.Regressions.Slug')">
            <rates-regressions
              :breakpoint="breakpoint"
              :bank-regression-data="bankRegressionData"
            />
          </v-tab-item>

          <!-- Peers Tab -->
          <v-tab-item :value="$t('Rates.Tab.Peers.Slug')">
            <rates-peers
              :breakpoint="breakpoint"
              :bank-regression-data="bankRegressionData"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { API } from '@/api/Api'
import i18nRouteMeta                     from '@/mixins/i18n/i18nRouteMeta'
import routerTabState                    from '@/mixins/routerTabState'
import SectionHeader                     from '@/theme/default/components/common/SectionHeader'
import RatesRegressions from '@/theme/default/views/banking/rates/RatesRegressions.vue'
import RatesPeers from '@/theme/default/views/banking/rates/RatesPeers.vue'
import RatesResource from '@/api/resources/rates/RatesResource'

export default {
  name      : 'Rates',
  components: {
    SectionHeader,
    RatesRegressions,
    RatesPeers
  },
  mixins   : [i18nRouteMeta, routerTabState],
  dataStore: {
    appToolbarExtended    : 'App.Config.AppToolbarExtended',
    FindBankRegressionData: 'Rates.FindBankRegressionData'
  },
  data () {
    return {
      breakpoint    : (this.appToolbarExtended && this.$vuetify.breakpoint.smAndDown ? 12 : 6),
      minBlockHeight: 364,
      editMode      : false
    }
  },
  computed: {
    breadcrumb () {
      return [{
        text    : this.$t('Rates.Title'),
        disabled: true
      }]
    },
    accountId () {
      return this.user?.selectedAccountId || null
    },
    bankRegressionData () {
      return this.FindBankRegressionData.Data || null
    }
  },
  watch: {
    activeTab: {
      immediate: true,
      handler (newTab) {
        if (!newTab) {
          this.activeTab = this.$t('Rates.Tab.Regressions.Slug')
        }
      }
    },
    appToolbarExtended (val) {
      this.breakpoint = val && this.$vuetify.breakpoint.smAndDown ? 12 : 6
    },

    '$vuetify.breakpoint.smAndDown': {
      handler (val) {
        this.breakpoint = val && this.appToolbarExtended ? 12 : 6
      }
    }
  },
  created () {
    this.findBankRegressionData()
  },
  methods: {
    async findBankRegressionData () {
      const response = await API.Resource.Rates.FindBankRegressionData(this.accountId)
      this.handleResponse(response, 'findBankRegressionData')
    },

    handleResponse (response, key) {
      const data = API.responseData(response)?.[key] || null

      const errors = API.responseErrors(response) || []

      if (API.isResponseSuccess(response) && data) {
        this.FindBankRegressionData.Data = RatesResource.fromApiResponse(data)
      } else {
        this.$bus.$emit('app:error', errors)
      }
    }
  }
}

</script>

<style scoped>
</style>
